export default __webpack_public_path__ + "static/media/okagoLogo.928cd906.svg";